import { BrowserRouter, Navigate, Route, Routes } from 'react-router'
import { useBahasa } from './i18n'
import { useSesi } from './auth'
import { PenyediaZona } from './zona'
import Login from './Login'
import { Tombol } from '../shared/ui'
import ShellTenant from '../shells/tenant/Shell'
import ShellSmovaAdmin from '../shells/smova-admin/Shell'
import DaftarTenant from '../shells/smova-admin/pages/DaftarTenant'
import TenantDetail from '../shells/smova-admin/pages/TenantDetail'
import Onboarding from '../shells/smova-admin/pages/Onboarding'
import JalurMasuk from '../shells/smova-admin/pages/JalurMasuk'
import Pemakaian from '../shells/smova-admin/pages/Pemakaian'
import Katalog from '../shells/smova-admin/pages/Katalog'
import Sistem from '../shells/smova-admin/pages/Sistem'
import ShellTenantAdmin from '../shells/tenant-admin/Shell'
import Beranda from '../shells/tenant-admin/pages/Beranda'
import Chatbot from '../shells/tenant-admin/pages/Chatbot'
import AturMeeting from '../shells/tenant-admin/pages/AturMeeting'
import PengetahuanTA from '../shells/tenant-admin/pages/Pengetahuan'
import SambunganSaya from '../shells/tenant-admin/pages/SambunganSaya'
import Tim from '../shells/tenant-admin/pages/Tim'
import PemakaianSaya from '../shells/tenant-admin/pages/PemakaianSaya'
import KontenAtur from '../shells/tenant-admin/pages/Konten'
import HariIni from '../shells/tenant/pages/HariIni'
import PerluDijawab from '../shells/tenant/pages/PerluDijawab'
import Prospek from '../shells/tenant/pages/Prospek'
import ProspekDetail from '../shells/tenant/pages/ProspekDetail'
import Meeting from '../shells/tenant/pages/Meeting'
import Konten from '../shells/tenant/pages/Konten'

function Gerbang({ children }) {
  const { sesi } = useSesi()
  if (!sesi) return <Login />
  return children
}

/**
 * Peran menentukan SELURUH pohon rute, bukan sekadar menu mana yang disembunyikan.
 *
 * Satu pintu login, tiga antarmuka (ADR-043). Sampai hari ini setiap peran mendarat
 * di layar Tenant Marketing — jadi operator Smova yang login melihat dashboard
 * tenant, bukan konsolnya sendiri.
 *
 * DIPISAH DI TINGKAT POHON, bukan dengan menyembunyikan menu. Menyembunyikan menu
 * meninggalkan rutenya tetap bisa dibuka lewat alamat, dan halaman yang terbuka
 * lewat alamat tapi tidak lewat menu adalah halaman yang tidak pernah diuji. Alamat
 * yang tidak dikenal di satu peran dibelokkan ke berandanya sendiri.
 *
 * Backend tetap yang menegakkan izinnya — ini cuma menentukan apa yang DIMINTA.
 * Kalau frontend yang jadi penjaganya, siapa pun yang membuka tab jaringan bisa
 * melewatinya.
 */
/**
 * Sesi yang perannya tidak dikenal. Bukan halaman galat biasa — ia menyebut apa yang
 * terjadi dan satu tindakan yang menyelesaikannya, karena keadaan ini SELALU akibat
 * sesi yang rusak sebagian, dan keluar-lalu-masuk selalu memperbaikinya.
 */
function PeranTidakDikenal({ peran }) {
  const { keluar } = useSesi()
  const { t } = useBahasa()
  return (
    <div className="min-h-screen grid place-items-center p-6">
      <div className="max-w-[54ch] flex flex-col gap-3 text-center">
        <b className="text-[16px]">{t('sesi.rusakJudul')}</b>
        <p className="m-0 text-[13px] text-ink2">
          {t('sesi.rusakKeterangan', { peran: peran || t('sesi.tanpaPeran') })}
        </p>
        <div><Tombol onClick={keluar}>{t('sesi.keluarMasuk')}</Tombol></div>
      </div>
    </div>
  )
}

function Rute() {
  const { sesi } = useSesi()

  if (sesi?.peran === 'smova_admin') {
    return (
      <Routes>
        <Route element={<ShellSmovaAdmin />}>
          <Route path="/" element={<Navigate to="/tenant" replace />} />
          <Route path="/tenant" element={<DaftarTenant />} />
          <Route path="/tenant/:id" element={<TenantDetail />} />
          <Route path="/tenant/:id/onboarding" element={<Onboarding />} />
          <Route path="/jalur-masuk" element={<JalurMasuk />} />
          <Route path="/pemakaian" element={<Pemakaian />} />
          <Route path="/katalog" element={<Katalog />} />
          <Route path="/sistem" element={<Sistem />} />
          <Route path="*" element={<Navigate to="/tenant" replace />} />
        </Route>
      </Routes>
    )
  }

  if (sesi?.peran === 'tenant_admin') {
    return (
      <Routes>
        <Route element={<ShellTenantAdmin />}>
          {/* Layar staf DIPAKAI ULANG apa adanya. Rutenya menuntut peran
              `tenant_marketing`, dan `tenant_admin` memenuhinya (ADR-051) — jadi
              admin melihat persis yang dilihat stafnya, ditambah dua menu miliknya. */}
          <Route path="/" element={<Navigate to="/beranda" replace />} />
          <Route path="/hari-ini" element={<HariIni />} />
          <Route path="/perlu-dijawab" element={<PerluDijawab />} />
          <Route path="/prospek" element={<Prospek />} />
          <Route path="/prospek/:id" element={<ProspekDetail />} />
          <Route path="/meeting" element={<Meeting />} />
          <Route path="/konten" element={<Konten />} />
          {/* DELAPAN menu panel admin (DESAIN_BACKOFFICE.md). Layar staf di atas
              TETAP bisa dibuka lewat alamat — mencabutnya akan jadi penurunan
              kemampuan yang tidak diminta siapa pun — tapi tidak lagi jadi menu. */}
          <Route path="/beranda" element={<Beranda />} />
          <Route path="/chatbot" element={<Chatbot />} />
          <Route path="/atur-meeting" element={<AturMeeting />} />
          <Route path="/atur-konten" element={<KontenAtur />} />
          <Route path="/pengetahuan" element={<PengetahuanTA />} />
          <Route path="/sambungan" element={<SambunganSaya />} />
          <Route path="/tim" element={<Tim />} />
          <Route path="/pemakaian-saya" element={<PemakaianSaya />} />
          {/* Alamat lama dipertahankan supaya tautan yang sudah dikirim orang tidak
              mati; isinya kini tab di dalam Chatbot. */}
          {/* Daftar fitur pindah dari tab Chatbot ke Beranda (ADR-067). Alamat lama
              tetap hidup supaya tautan yang pernah dikirim orang tidak mati. */}
          <Route path="/fitur" element={<Navigate to="/beranda" replace />} />
          <Route path="/model" element={<Navigate to="/chatbot" replace />} />
          <Route path="/field-profil" element={<Navigate to="/chatbot" replace />} />
          <Route path="*" element={<Navigate to="/beranda" replace />} />
        </Route>
      </Routes>
    )
  }

  // PERAN YANG TIDAK DIKENAL BUKAN `tenant_marketing`.
  //
  // Cabang terakhir ini dulu menerima apa pun yang bukan dua peran di atas — termasuk
  // peran yang KOSONG. Akibatnya nyata dan sulit ditelusuri: sesi yang rusak sebagian
  // (token ada, sesi tidak) membuat `sesi?.peran` undefined, operator Smova mendarat di
  // dashboard Tenant Marketing, dan setiap permintaan membawa tokennya sendiri tanpa
  // `X-Tenant-Id` — muncul sebagai "Operator Smova harus menyebut tenant lewat header
  // X-Tenant-Id" di layar yang seharusnya tidak pernah ia buka.
  //
  // Menebak peran berarti menebak DASHBOARD SIAPA yang ditampilkan. Lebih baik berhenti.
  if (sesi && sesi.peran !== 'tenant_marketing') {
    return <PeranTidakDikenal peran={sesi.peran} />
  }

  return (
    <Routes>
      {/*
        Bentuk URL ditetapkan sejak awal karena ia kontrak: tautan ke satu prospek
        harus bisa dikirim lewat WhatsApp dan dibuka orang lain. Rute yang tidak
        punya alamat sendiri memaksa "klik ini, lalu itu" — dan itu yang membuat
        orang kembali ke Telegram.
      */}
      <Route element={<ShellTenant />}>
        <Route path="/" element={<Navigate to="/hari-ini" replace />} />
        <Route path="/hari-ini" element={<HariIni />} />
        <Route path="/perlu-dijawab" element={<PerluDijawab />} />
        <Route path="/prospek" element={<Prospek />} />
        <Route path="/prospek/:id" element={<ProspekDetail />} />
        <Route path="/meeting" element={<Meeting />} />
        <Route path="/konten" element={<Konten />} />
        <Route path="*" element={<Navigate to="/hari-ini" replace />} />
      </Route>
    </Routes>
  )
}

/**
 * Tampilan LAMA. Penyedia bahasa, kueri, dan sesi ada di `Akar.jsx`, dipakai bersama
 * tampilan rancang ulang; berkas ini tinggal pohon rutenya. Dicabut bersama layar lama
 * (RENCANA langkah 4, tahap 5).
 */
export default function App() {
  return (
    <BrowserRouter>
      {/* DI LUAR <Gerbang>, bukan di dalamnya. Gerbang mengganti isinya dengan
          layar masuk begitu sesi hilang — jadi penyedia yang ada di DALAMNYA
          ikut dilepas, dan effect yang mengembalikan zona ke bawaan saat keluar
          tidak pernah sempat berjalan. Zona tenant sebelumnya akan tertinggal
          untuk siapa pun yang masuk berikutnya di tab yang sama. */}
      <PenyediaZona>
        <Gerbang>
          <Rute />
        </Gerbang>
      </PenyediaZona>
    </BrowserRouter>
  )
}
